import React from 'react';
import { FadeIn } from './FadeIn';
export function AboutMe() {
  return <section className="relative py-24 md:py-32 bg-forest overflow-hidden" data-id="element-24">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-25">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/5 rounded-full blur-3xl" data-id="element-26"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-white/5 rounded-full blur-3xl" data-id="element-27"></div>

        {/* Large background text */}
        <div className="absolute top-1/2 right-0 -translate-y-1/2 text-[40vw] font-serif font-bold text-ivory/[0.03] leading-none select-none" data-id="element-28">
          M
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-29">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-30">
          {/* Left Side - Photo */}
          <div className="lg:col-span-5" data-id="element-31">
            <FadeIn direction="left" data-id="element-32">
              <div className="relative" data-id="element-33">
                <div className="absolute -top-6 -left-6 w-32 h-32 bg-gold/10 rounded-full blur-2xl -z-10" data-id="element-34"></div>
                <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-ivory/10 rounded-full blur-2xl -z-10" data-id="element-35"></div>

                <div className="rounded-[32px] overflow-hidden border border-white/10 shadow-2xl relative" data-id="element-36">
                  <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu" className="w-full h-auto object-cover aspect-[3/4]" data-id="element-37" />
                  {/* Subtle overlay to blend photo with dark background */}
                  <div className="absolute inset-0 bg-forest/10 mix-blend-multiply pointer-events-none" data-id="element-38"></div>
                </div>

                {/* Decorative element */}
                <div className="absolute -bottom-8 -right-8 w-24 h-24 border-2 border-gold/20 rounded-full -z-10" data-id="element-39"></div>
              </div>
            </FadeIn>
          </div>

          {/* Right Side - Text */}
          <div className="lg:col-span-7" data-id="element-40">
            <FadeIn data-id="element-41">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-ivory mb-8 text-left" data-id="element-42">
                Cine sunt eu și de ce am creat acest program
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-43">
              <div className="space-y-5 text-ivory/80 font-sans text-[19px] leading-relaxed text-left" data-id="element-44">
                <p className="font-medium text-gold text-xl" data-id="element-45">
                  Sunt Mihaela Iovu. Master Trainer NLP, facilitator Constelații
                  Familiale, Master Coach acreditat și formator certificat de
                  Ministerul Muncii.
                </p>

                <p data-id="element-46">
                  Am lucrat 16 ani în contabilitate și taxe, în mediul
                  corporate, unde am văzut de aproape ce înseamnă stresul
                  cronic, oboseala care nu mai trece și burnout-ul care se
                  instalează tăcut. Am trecut eu însămi prin divorț, prin
                  reconstrucție de la zero, prin momente în care m-am întrebat:{' '}
                  <span className="font-serif italic text-gold text-xl" data-id="element-47">
                    „Și eu acum ce fac?”
                  </span>
                </p>

                <p data-id="element-48">
                  Din acele momente, și din munca mea cu zeci de femei care
                  trăiau același lucru, a crescut metoda A.R.I.S.E. Este
                  procesul prin care lucrez astăzi cu clientele mele și este
                  fundația programului ANIMA Recode.
                </p>

                <p data-id="element-49">
                  Nu cred în soluții rapide. Cred în procese reale, ghidate,
                  care merg în profunzime. Integrez NLP, constelații familiale,
                  hipnoză și coaching într-o metodă structurată, aplicată pe
                  viața reală, care te duce de la{' '}
                  <span className="font-serif italic text-gold text-xl" data-id="element-50">
                    „funcționez"
                  </span>{' '}
                  la{' '}
                  <span className="font-serif italic text-gold text-xl" data-id="element-51">
                    „trăiesc"
                  </span>
                  .
                </p>

                <div className="mt-8 pt-6 border-t border-white/10" data-id="element-52">
                  <p className="font-medium text-ivory" data-id="element-53">
                    ANIMA Recode este programul în care pun tot ce am învățat în
                    ultimii ani despre cum se întâmplă schimbarea reală la o
                    femeie adultă, cu responsabilități și cu istoric.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}